export const sharedRu = {
  theme: {
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Системная',
    switchAria: 'Сменить тему',
  },
  sidebar: {
    brand: 'upme admin',
    groups: {
      overview: 'Обзор',
      content: 'Контент',
      import: 'Импорт',
      community: 'Сообщество',
      crm: 'CRM',
      monetization: 'Монетизация',
      system: 'Система',
    },
    nav: {
      home: 'Главная',
      events: 'События',
      eventCategories: 'Категории событий',
      places: 'Места',
      placeCategories: 'Категории мест',
      services: 'Услуги',
      serviceCategories: 'Категории услуг',
      news: 'Новости',
      sourceChannels: 'Источники',
      extractorConfig: 'Парсер событий',
      organizerBlocks: 'Блокировки организаторов',
      importQueue: 'Импорт-очередь',
      users: 'Пользователи',
      crmBoard: 'Доска',
      crmConversations: 'Переписки',
      crmTelegram: 'Telegram',
      crmInstagram: 'Instagram',
      meetingTemplates: 'Быстрый старт',
      photoModeration: 'Модерация фото',
      promotionTasks: 'Продвижение',
      coinTransactions: 'Энергия',
      paymentProviders: 'Платежи',
      cities: 'Города',
      morningDigest: 'Утренняя рассылка',
    },
    account: 'Аккаунт',
    logout: 'Выйти',
  },
  support: {
    contactAdmin: 'Свяжитесь с администратором.\nПожалуйста, пришлите скриншот ошибки.',
    writeUs: 'Написать нам',
  },
};

export type SharedBundle = typeof sharedRu;
